import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { FileType } from '~/types';

type CoursesSliceType = {
  formTemplatesPagination: {
    isLoading: boolean;
    items: Record<string, unknown>[];
    pageInfo: Record<string, unknown>;
  };
  formTemplates: [];
};

const initialState: CoursesSliceType = {
  formTemplatesPagination: {
    isLoading: false,
    items: [],
    pageInfo: {
      hasPreviousPage: false,
      hasNextPage: false,
      currentPage: 1,
      perPage: 1,
      itemCount: 0,
      pageCount: 1,
    },
  },
  formTemplates: [],
};

export const formTemplatesSlice = createSlice({
  name: 'formTemplates',
  initialState,
  reducers: {
    setFormTemplatesPagination: (state, action: PayloadAction<FileType | null>) => {
      state.formTemplatesPagination = action.payload;
    },
    setFormTemplates: (state, action: PayloadAction<FileType | null>) => {
      state.formTemplates = action.payload;
    },
  },
});

export const { setFormTemplates, setFormTemplatesPagination } = formTemplatesSlice.actions;
